import type { ItemUI } from '@libs/common-node';

import { EXISTING_CART_LIST_ID, EXISTING_CART_LIST_NAME } from '../constants/itemListAttribution';
import {
    type Ga4ItemListAttribution,
    getGa4ItemListAttributionFromSkuFindingMethod,
} from './ga4ItemListAttributionFromSkuFindingMethod';
import { getSkuFindingMethod } from './skuFindingMethodStorage';

const APP_PETM_CHANNELS = new Set(['ios', 'android']);

const isAppOriginatedItem = (item: Pick<ItemUI, 'petmChannel'>): boolean => {
    const channel = item.petmChannel?.toLowerCase();
    return channel != null && APP_PETM_CHANNELS.has(channel);
};

const hasWebAttribution = (sku: string): boolean => getSkuFindingMethod(sku) !== '';

export const resolveGa4ItemListAttributionForCartItem = (
    item: Pick<ItemUI, 'sku' | 'petmChannel'>
): Ga4ItemListAttribution => {
    if (isAppOriginatedItem(item) && !hasWebAttribution(item.sku)) {
        return {
            item_list_id: EXISTING_CART_LIST_ID,
            item_list_name: EXISTING_CART_LIST_NAME,
        };
    }

    return getGa4ItemListAttributionFromSkuFindingMethod(getSkuFindingMethod(item.sku));
};
